module.exports = __webpack_public_path__ + "static/media/playing_guitar.a090200c.gif";